export default {
  // 🧍 Gender
  genderOptions: ["Male", "Female"],

  // 🧕 Appearance
  appearanceOptionsByGender: {
    Male: [
      "Full Beard",
      "Trimmed Beard",
      "Goatee",
      "Clean Shaven",
      "Prefer not to say",
    ],
    Female: [
      "Hijabi (Headscarf)",
      "Niqabi (Face veil)",
      "Non-Hijabi",
      "Prefer not to say",
    ],
  },
  hajjStatusOptions: [
    'Performed Hajj (on my own)',
    'Performed Hajj (with family)',
    'Planning to perform soon, InshaAllah',
    'Not yet performed',
  ],
  umrahStatusOptions: [
    'Performed Umrah (on my own)',
    'Performed Umrah (with family)',
    'Multiple times',
    'Not yet performed',
  ],
  siblingOrderOptions: [
    'Only child',
    'Oldest / First-born',
    'Second-born',
    'Middle child',
    'Youngest',
    'One of the youngest',
    'One of the oldest',
  ],
  personalityTypeOptions: [
    'Calm and quiet',
    'Outgoing and social',
    'Balanced',
    'Depends on mood',
  ],
  eatOutFrequencyOptions: ['Rarely', 'Once a week', 'Few times a week', 'Daily'],
  weekendActivityOptions: [
    'Family time',
    'With friends',
    'Reading / studying',
    'Traveling',
    'Resting at home',
  ],
  foodPreferenceOptions: [
    'Homemade',
    'Restaurant',
    'Fast food',
    'Healthy',
    'Traditional cultural',
    'Mixed',
  ],
  dietTypeOptions: [
    'Halal only',
    'Zabiha Halal',
    'Vegetarian',
    'Vegan',
    'No preference',
  ],
  travelFrequencyOptions: [
    'Rarely',
    'Once a year',
    'Few times a year',
    'Very frequently',
  ],
  occupationTypeOptions: [
    'Employed',
    'Self-Employed',
    'Student',
    'Homemaker',
    'Unemployed',
    'Retired',
  ],
  cookingSkillOptions: [
    'I do not cook',
    'Beginner - learning',
    'Average - cook simple meals',
    'Good - cook regularly',
    'Excellent - love cooking and trying new recipes',
  ],

  employmentStatusOptions: [
    'Full-time',
    'Part-time',
    'Freelancer',
    'Contract',
    'Intern',
    'Looking for work',
  ],
  workEnvironmentOptions: [
    'Work from Home',
    'On-site Office',
    'Hybrid (Office + Home)',
    'Field Work / Travel-Based',
  ],
  travelForWorkTravelFrequencyOptions: [
    'Occasionally (few times a year)',
    'Frequently (monthly)',
    'Very Often (weekly)',
  ],
  vehicleTypeOptions: [
    'Sedan',
    'SUV',
    'Truck',
    'Van',
    'Electric / Hybrid',
    'Other',
  ],
  transportModeOptions: [
    'Own Car',
    'Public Bus',
    'Subway / Train',
    'Carpool / Rideshare (Uber/Lyft)',
    'Walk / Bicycle',
    'Other',
  ],
  postMarriageWorkOptions: [
    'Would like to continue working',
    'Open to discuss with spouse',
    'Prefer to focus on home/family',
    'Not sure yet',
  ],
  wifeWorkPreferenceOptions: [
    'I prefer my wife to work',
    'I prefer my wife to stay home',
    'I am open to either, depending on her preference',
  ],
  financialResponsibilityOptions: [
    'I will be the sole financial provider',
    'I expect shared financial responsibility',
    'We will decide together after marriage',
  ],
  domesticContributionOptions: [
    'I will help with house chores and childcare',
    'My wife will manage home tasks primarily',
    'We will share responsibilities equally',
  ],
  isRevertOptions: ['Yes, I am a revert',
    'No',
    'Born Muslim',
    'Prefer not to say'
  ],
  homeAtmosphereOptions: ['Quiet and calm', 'Lively with family & kids', 'Flexible'],
  timePreferenceOptions: ['Early morning', 'Night owl', 'Flexible'],
  livingPreferenceOptions: ['City life', 'Suburban life', 'Countryside', 'No preference'],
  brotherCountOptions: [0, 1, 2, 3, 4, 5, 6, 'More than 6'],
  sisterCountOptions: [0, 1, 2, 3, 4, 5, 6, 'More than 6'],
  buildOptions: ['Athletic', 'Average', 'Curvy', 'Large', 'Thin', 'Medium'],
  complexionOptions: ['Fair', 'Wheatish', 'Tan', 'Brown', 'Dark', 'Other'],
  islamicEducationOptions: [
    "None",
    "Madrassah",
    "Darul Uloom",
    "Islamic Seminary",
    "Islamic University",
    "Further Studies",
    "Islamic Theology",
  ],

  prayerOptions: [
    "Pray 5 times daily",
    "3–4 times daily",
    "Occasionally / Jummah only",
    "Only Eid prayers",
    "Trying to be regular",
  ],

  // 🕌 Prayer
  prayerFrequencyOptions: [
    "Five times a day",
    "Three to four times",
    "Once or twice a day",
    "Only on Jummah",
    "Only on Eid",
    "Occasionally",
    "Rarely",
    "Never",
  ],

  // 🌍 Ethnicity
  ethnicityOptions: [
    "Pakistani",
    "Indian",
    "Bangladeshi",
    "Afghan",
    "Arab",
    "African",
    "African American",
    "European",
    "Caribbean",
    "Turkish",
    "Indonesian",
    "Malaysian",
    "Other South Asian",
    "Mixed",
    "Other",
  ],

  // 🛂 Legal Status
  legalStatusOptions: [
    "Citizen",
    "Green Card",
    "Work Visa",
    "Student Visa",
    "Visitor",
    "Other",
    "Unknown",
  ],

  // 🎓 Education
  educationOptions: [
    "High School",
    "Bachelor’s",
    "Master’s",
    "PhD",
    "Other",
  ],

  // 🕌 Islamic Education
  islamicEduOptions: [
    "None",
    "Madrassah (basic study)",
    "Hifz (Hafiz/Hafiza)",
    "Darul Uloom (Alim/Alimah)",
    "Islamic Seminary",
    "Islamic University",
    "Part-time Islamic Study",
    "Further Religious Study",
  ],

  // 🧠 Madhab
  madhabOptions: [
    "Hanafi",
    "Shafi’i",
    "Maliki",
    "Hanbali",
    "Salafi",
  ],

  // 🏠 Living Arrangement
  livingArrangementOptions: [
    "I plan to live separately with my spouse",
    "I will live with my parents (joint family)",
    "I prefer my spouse to live with my family",
    "Open to either, depending on circumstances",
  ],

  // 👶 Family
  childrenCountOptions: [1, 2, 3, 4, 5, 6, "More than 6"],
  siblingCountOptions: [1, 2, 3, 4, 5, 6, "More than 6"],

  // 🌍 Countries and States (Global)
  countries: [
    "United States", "Canada", "United Kingdom", "Australia", "Pakistan",
    "India", "Bangladesh", "Saudi Arabia", "United Arab Emirates", "Qatar",
    "Kuwait", "Bahrain", "Oman", "Malaysia", "Indonesia", "Turkey",
    "South Africa", "Nigeria", "France", "Germany", "Italy", "Spain",
    "Netherlands", "Norway", "Sweden", "Denmark", "Switzerland", "Egypt",
    "Morocco", "Tunisia", "Jordan", "Lebanon", "Somalia", "Ethiopia",
    "Sudan", "Kenya", "Tanzania", "Singapore", "Philippines", "China",
    "Japan", "South Korea"
  ],

  statesByCountry: {
    "United States": [
      "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
      "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho",
      "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana",
      "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota",
      "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
      "New Hampshire", "New Jersey", "New Mexico", "New York",
      "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon",
      "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
      "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington",
      "West Virginia", "Wisconsin", "Wyoming"
    ],
    "Canada": [
      "Alberta", "British Columbia", "Manitoba", "New Brunswick",
      "Newfoundland and Labrador", "Nova Scotia", "Ontario",
      "Prince Edward Island", "Quebec", "Saskatchewan"
    ],
    "United Kingdom": [
      "England", "Scotland", "Wales", "Northern Ireland"
    ],
    "Australia": [
      "New South Wales", "Queensland", "South Australia", "Tasmania",
      "Victoria", "Western Australia", "Northern Territory"
    ],
    "Pakistan": [
      "Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan",
      "Gilgit-Baltistan", "Azad Jammu & Kashmir", "Islamabad Capital Territory"
    ],
    "India": [
      "Delhi", "Maharashtra", "Uttar Pradesh", "Gujarat", "Karnataka",
      "Tamil Nadu", "Kerala", "West Bengal", "Punjab", "Haryana",
      "Madhya Pradesh", "Rajasthan", "Andhra Pradesh", "Telangana",
      "Bihar", "Odisha", "Assam", "Goa"
    ],
    "Bangladesh": [
      "Dhaka", "Chittagong", "Khulna", "Rajshahi", "Sylhet",
      "Barisal", "Rangpur", "Mymensingh"
    ],
    "United Arab Emirates": [
      "Abu Dhabi", "Dubai", "Sharjah", "Ajman", "Umm Al Quwain",
      "Ras Al Khaimah", "Fujairah"
    ],
    "Saudi Arabia": [
      "Riyadh", "Makkah", "Madinah", "Eastern Province", "Qassim",
      "Asir", "Tabuk", "Hail", "Northern Borders", "Jazan", "Najran",
      "Al Bahah", "Al Jouf"
    ],
    "Malaysia": [
      "Selangor", "Kuala Lumpur", "Penang", "Johor", "Perak",
      "Kedah", "Kelantan", "Terengganu", "Pahang", "Negeri Sembilan",
      "Melaka", "Perlis", "Sabah", "Sarawak"
    ],
    "Turkey": [
      "Istanbul", "Ankara", "Izmir", "Bursa", "Antalya", "Konya",
      "Adana", "Gaziantep", "Mersin", "Kayseri"
    ],
    "South Africa": [
      "Gauteng", "Western Cape", "KwaZulu-Natal", "Eastern Cape",
      "Free State", "Limpopo", "Mpumalanga", "Northern Cape", "North West"
    ]
  },
  relationOptions: [
    "Father",
    "Mother",
    "Brother",
    "Sister",
    "Uncle",
    "Aunt",
    "Guardian",
    "Self",
    "Other",
  ],

  // 🗣️ Languages Spoken
  languageOptions: [
    "English",
    "Urdu",
    "Arabic",
    "Hindi",
    "Bengali",
    "Punjabi",
    "Turkish",
    "Malay",
    "Indonesian",
    "French",
    "Spanish",
    "Persian (Farsi)",
    "Somali",
    "Swahili",
    "German",
    "Italian",
    "Tamil",
    "Gujarati",
    "Pashto",
    "Kurdish",
    "Chinese (Mandarin)",
    "Japanese",
    "Korean",
    "Russian",
    "Other",
  ],

  // 📏 Height
  feetOptions: [4, 5, 6, 7],
  inchOptions: Array.from({ length: 12 }, (_, i) => i),

  maritalStatusOptions: ['Never Married', 'Divorced', 'Widowed', 'Separated'],
  // ⏱ Other shared data
  months: [
    { text: "January", value: 1 },
    { text: "February", value: 2 },
    { text: "March", value: 3 },
    { text: "April", value: 4 },
    { text: "May", value: 5 },
    { text: "June", value: 6 },
    { text: "July", value: 7 },
    { text: "August", value: 8 },
    { text: "September", value: 9 },
    { text: "October", value: 10 },
    { text: "November", value: 11 },
    { text: "December", value: 12 },
  ],
};